export default [
  {
    background: '#3347C1',
    font: '#fff'
  },
  {
    background: '#00A791',
    font: '#fff'
  },
  {
    background: '#008298',
    font: '#fff'
  },
  {
    background: '#C57BBC',
    font: '#000'
  },
  {
    background: '#FFC886',
    font: '#000'
  },
  {
    background: '#F36B62',
    font: '#fff'
  },
  {
    background: '#DB6200',
    font: '#fff'
  }
];
